import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import PanelCard from '../../PanelCards/components/PanelCard';
import Button from '@material-ui/core/Button';
import Hidden from '@material-ui/core/Hidden';
import OpenInNew from '@material-ui/icons/OpenInNew';
import InteractiveMap from '../../../SolvPatternLibrary/InteractiveMap/index';
import DefaultPin from '../../../SolvPatternLibrary/InteractiveMap/DefaultPin';
import { colors } from '../../../../constants/colors';
import { fontSize, fontFamily } from '../../../../constants/text';
import { biggerThanOrEqualTo } from '../../../../core/util/styledComponents';
import { getGoogleDirectionsUrl } from '../../../../core/util/location';
import ClinicAddress, { ADDRESS_FORMAT } from './../../HeaderCard/components/ClinicAddress';
import { getDefaultBreakpoint } from '../../../../core/util/device/screen';
import { analyticsTrackEvent } from '../../../../core/analytics';
import { CDP_CLICK_DIRECTION_MAP_SECTION } from '../../../../core/analytics/events';

const Root = styled.div`
  width: 100%;
`;

const MapContainer = styled.div`
  border-radius: 4px;
  border: 1px solid ${colors.greyHounds};
  width: 100%;
`;

const Map = styled(InteractiveMap)`
  height: 50vw;
  max-height: 300px;
  width: 100%;
`;

const GetDirectionSection = styled.div`
  min-height: 50px;
  background: ${colors.whiteGrey};
  display: flex;
  align-items: center;
  justify-content: center;
  ${biggerThanOrEqualTo.md`
    justify-content: space-between;
  `};
`;

const buttonTextStyle = css`
  color: ${colors.squid};
  font-size: ${fontSize.mediumSmall};
  font-family: ${fontFamily.book};
  text-transform: capitalize;
`;

const EmbeddedDirectionsButton = styled(Button)`
  ${buttonTextStyle};
  letter-spacing: -0.2px;
  height: 40px;
  background-color: ${colors.white};
  margin-right: 10px;
  border: 1px solid ${colors.dorianGrey};
`;

const StandaloneDirectionsButton = styled(Button)`
  background-color: ${colors.fatherJohnMisty};
  width: 100%;
  margin-top: 20px;
  ${buttonTextStyle};
`;

const DirectionsIcon = styled(OpenInNew)`
  font-size: ${fontSize.default};
  margin-left: 8px;
  margin-bottom: 2px;
`;

const StyledMapIcon = styled.img`
  margin-right: 8px;
`;

const StyledClinicAddress = styled(ClinicAddress)`
  cursor: pointer;
  color: ${colors.blueJayWay};
  & > span {
    vertical-align: sub;
  }
`;

const AddressContainer = styled.div`
  margin-left: 10px;
  display: flex;
`;

const AddressPinContainer = styled.span`
  vertical-align: sub;
  margin-right: 5px;
`;

class MapAndDirections extends Component {
  genMapMarkers = () => {
    const {
      location: { latLong },
    } = this.props;
    const currentLocationMarker = {
      lat: latLong.latitude,
      lng: latLong.longitude,
      Marker: DefaultPin,
    };
    return [currentLocationMarker];
  };

  handleGetDirection = () => {
    const {
      location,
      location: { id, uclId },
    } = this.props;
    window.open(getGoogleDirectionsUrl(location));
    analyticsTrackEvent(CDP_CLICK_DIRECTION_MAP_SECTION, {
      locationId: id,
      uclId,
    });
  };

  render = () => {
    const { location, enableCollapsing, defaultExpanded } = this.props;

    return (
      <PanelCard title="Map & Directions" {...{ enableCollapsing, defaultExpanded }}>
        <Root>
          <MapContainer>
            <Map markers={this.genMapMarkers()} />
            <GetDirectionSection onClick={this.handleGetDirection}>
              <AddressContainer>
                <AddressPinContainer>
                  <DefaultPin />
                </AddressPinContainer>
                <StyledClinicAddress
                  shouldAddSchema={false}
                  type={ADDRESS_FORMAT.VERBOSE}
                  location={location}
                />
              </AddressContainer>
              <Hidden smDown initialWidth={getDefaultBreakpoint()}>
                <EmbeddedDirectionsButton>
                  Get Directions
                  <DirectionsIcon />
                </EmbeddedDirectionsButton>
              </Hidden>
            </GetDirectionSection>
          </MapContainer>
          <Hidden mdUp initialWidth={getDefaultBreakpoint()}>
            <StandaloneDirectionsButton onClick={this.handleGetDirection} disableRipple>
              <StyledMapIcon src="/images/icons/Icon-Directions.svg" alt="Directions icon" />
              Get Directions
            </StandaloneDirectionsButton>
          </Hidden>
        </Root>
      </PanelCard>
    );
  };
}

export default MapAndDirections;

MapAndDirections.propTypes = {
  location: PropTypes.object.isRequired,
  enableCollapsing: PropTypes.bool,
  defaultExpanded: PropTypes.bool,
};

MapAndDirections.defaultProps = {
  location: {
    latLong: {},
  },
};
